<template>
  <v-row class="pt-0">
    <v-col cols="12" xs="12" class="pa-0">
    <v-card class="pa-4 pt-0">
      <v-row justify="start" class="py-0">
        <v-breadcrumbs :items="crump" divider=">" color="#808080"></v-breadcrumbs>
      </v-row>
      <v-row class="py-0">
        <v-col cols="6" xs="12" class="pt-0">
          <v-card-text>
            <span class="headline"  v-if="companyData.typ === 1">(Veranstalter) </span>
            <span class="headline font-weight-light">Netzwerk "{{companyData.name}}"</span>
          </v-card-text>
        </v-col>
        <v-col cols="6" xs="12" style="text-align: right">
          <v-btn @click="close" icon color="red"><v-icon>close</v-icon></v-btn>
        </v-col>
      </v-row>
      <v-tabs
      v-model="tab"
      background-color="#EEEEEE"
      color="black"
      @change="onChangeTab"
      >
        <v-tab key="tab0" href="#tab0" v-if="isAllowed('RNETWORK_TAB_STAMMDATA')">Stammdaten</v-tab>
        <v-tab key="tab7" href="#tab7" v-if="isAllowed('RNETWORK_TAB_COMMENTS')">Kommentare</v-tab>
        <v-tab key="tab4" href="#tab4" v-if="isAllowed('RNETWORK_TAB_USER')">Benutzer</v-tab>
        <v-tab key="tab5" href="#tab5" v-if="isAllowed('RNETWORK_TAB_ROLE')">Rollen</v-tab>
        <v-tab key="tab1" href="#tab1" v-if="isAllowed('RNETWORK_TAB_PLAYLIST')">Playlist</v-tab>
        <v-tab key="tab2" href="#tab2" v-if="isAllowed('RNETWORK_TAB_DEVICES')">Geräte</v-tab>
        <v-tab key="tab3" href="#tab3" v-if="isAllowed('RNETWORK_TAB_LOCATIONS') && companyData.typ !== 1">Standorte</v-tab>
        <v-tab key="tab6" href="#tab6" v-if="isAllowed('RNETWORK_TAB_MEDIA')">Medien</v-tab>
        <v-tab key="tab8" href="#tab8" v-if="isAllowed('RNETWORK_TAB_IMPORT') && companyData.typ !== 1">Import</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item key="tab0" value="tab0" v-if="isAllowed('RNETWORK_TAB_STAMMDATA')">
          <TabDefault ref="tab0" :tagList="tagList" :company-id="companyId" :form-data="companyData"></TabDefault>
        </v-tab-item>
        <v-tab-item key="tab7" value="tab7" v-if="isAllowed('RNETWORK_TAB_COMMENTS')">
          <TableComments ref="tab7" :tagList="tagList" :company-id="companyId" :form-data="companyData"></TableComments>
        </v-tab-item>
        <v-tab-item key="tab4" value="tab4" v-if="isAllowed('RNETWORK_TAB_USER')">
          <TabUser ref="tab4" :company-id="companyId" :form-data="companyData"></TabUser>
        </v-tab-item>
        <v-tab-item key="tab5" value="tab5" v-if="isAllowed('RNETWORK_TAB_ROLE')">
          <TabRoles ref="tab5" :company-id="companyId" :form-data="companyData"></TabRoles>
        </v-tab-item>
        <v-tab-item key="tab1" value="tab1" v-if="isAllowed('RNETWORK_TAB_PLAYLIST')">
          <TabPlaylist ref="tab1" :company-id="companyId" :form-data="companyData"></TabPlaylist>
        </v-tab-item>
        <v-tab-item key="tab2" value="tab2" v-if="isAllowed('RNETWORK_TAB_DEVICES')">
          <TabDevices ref="tab2" :company-id="companyId" :form-data="companyData"></TabDevices>
        </v-tab-item>
        <v-tab-item key="tab3" value="tab3" v-if="isAllowed('RNETWORK_TAB_LOCATIONS')">
          <TabStandorte ref="tab3" :company-id="companyId" :form-data="companyData"></TabStandorte>
        </v-tab-item>
        <v-tab-item key="tab6" value="tab6" v-if="isAllowed('RNETWORK_TAB_MEDIA')">
          <TabMedien ref="tab6" :company-id="companyId" :form-data="companyData"></TabMedien>
        </v-tab-item>
        <v-tab-item key="tab8" value="tab8" v-if="isAllowed('RNETWORK_TAB_IMPORT')">
          <TabImport ref="tab8" :company-id="companyId" :form-data="companyData"></TabImport>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import TabDefault from './TabDefault'
import TabDevices from "./TabDevices"
import TabPlaylist from "./TabPlaylist"
import TabStandorte from "./TabStandorte"
import TabUser from "./TabUser"
import TabRoles from "./TabRoles"
import TabMedien from "./TabMedien"
import TableComments from "@/components/tables/TableComments";
import TabImport from "@/components/module/company/TabImport.vue";

export default {
  name: 'CompanyDefault',
  components: {TabImport, TableComments, TabDevices, TabDefault, TabPlaylist, TabStandorte,TabUser,TabRoles, TabMedien},
  data () {
    return {
      tab: 'tab1',
      companyId: '-1',
      tagList: [],
      crump: [{
        text: 'Dashboard',
        disabled: false,
        href: '/#/Dashboard/Netzwerke',
      }],
      companyData: {
        name: '',
        costCenter: '',
        street: '',
        zip: '',
        city: '',
        email: '',
        phone: '',
        create: '',
        changed: ''
      }
    }
  },
  methods: {
    isAllowed: function (name) {
      var ownAllowed = Vue.prototype.$apiRight.hasRight(name + '_OWN')

      //return Vue.prototype.$apiRight.hasRight('RIGHT_NETWORK_OPEN_OTHER', {
      //  orClausel: ownAllowed && (item.guid === Vue.prototype.$api.getCredentials().data.guidParent)
      //})
      return ownAllowed
    },
    onChangeTab: function() {
      const cmp = this
      this.$nextTick(function () {
        window.setTimeout(function () {
          if (cmp.$refs[''+cmp.tab] && cmp.$refs[''+cmp.tab].reload) {
            cmp.$refs[''+cmp.tab].reload()
          }
        }, 500)
        // console.log('onChangeTab',cmp.tab, cmp.$refs[''+cmp.tab], cmp.tab,cmp.$refs,cmp.$refs.hasOwnProperty(cmp.tab))
      })
    },

    onGetData: function (data) {
      console.log('company', data)
      if (data.tags === null) {
        data.tags = '[]'
      }
      data.tags = JSON.parse(data.tags)
      this.companyData = data
    },
    close: function () {
      window.history.back();
    }
  },
  mounted () {
    this.companyId = this.$route.params.companyId
    if (this.$route.params.locationId) {
      this.companyId = this.$route.params.locationId
    }
    Vue.prototype.$apiCompany.loadCompany(this.companyId, this.onGetData)
    if (this.$route.params.tabId) {
      this.tab = 'tab' + this.$route.params.tabId * 1
    }
    var cmp = this
    window.setTimeout(function () {
      console.log('refs', cmp.$refs, cmp.tab)
      if (cmp.$refs['tab' + cmp.tab]) {
        cmp.$refs['tab' + cmp.tab].open()
      }
    }, 500)
  }
}
</script>

<style scoped>

</style>
